import { useMemo } from "react";

import type { IPlainObject } from "app/pages/sales-intelligence/types/plainObject";

import type { IFilterManagerModel } from "../services/filters-manager/types";
import type { FilterValueDeltaList } from "../types/misc";

type HookParams<T extends IPlainObject = IPlainObject> = {
    currentFiltersValue: Partial<T>;
    filtersManager: IFilterManagerModel<T>;
    filtersList: Partial<T>;
};

export const useFiltersValueDeltas = <T extends IPlainObject = IPlainObject>({
    filtersList,
    filtersManager,
    currentFiltersValue,
}: HookParams<T>): Readonly<FilterValueDeltaList> => {
    return useMemo((): FilterValueDeltaList => {
        return Object.entries(filtersList).reduce((acc, [filterKey, filterValue]: [keyof T, T[keyof T]]) => {
            const filterConfig = filtersManager.getFilterConfig(filterKey);

            if (!filterConfig) {
                return acc;
            }

            const valueDelta = filterConfig.filter.calculateValueDeltaFromDto(
                filterValue,
                currentFiltersValue[filterKey],
            );

            acc[filterKey as string] = valueDelta;

            return acc;
        }, {} as FilterValueDeltaList);
    }, [filtersList, currentFiltersValue, filtersManager]);
};
